import { Navigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GetCurrentUserDocument } from '@/graphql/getCurrentUser.api';

interface GuestRouteProps {
  children: React.ReactNode;
}

export function GuestRoute({ children }: GuestRouteProps) {
  const { data, loading } = useQuery(GetCurrentUserDocument, {
    fetchPolicy: 'cache-and-network',
  });

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (data?.currentUser) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
